import * as ambassadorWixContactsV4Attachment from './contacts-v4-attachment-attachments.http.js';
import * as ambassadorWixContactsV4AttachmentTypes from './contacts-v4-attachment-attachments.types.js';
import * as ambassadorWixContactsV4AttachmentUniversalTypes from './contacts-v4-attachment-attachments.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function generateAttachmentUploadUrl(): __PublicMethodMetaInfo<
  'POST',
  { contactId: string },
  ambassadorWixContactsV4AttachmentUniversalTypes.GenerateAttachmentUploadUrlRequest,
  ambassadorWixContactsV4AttachmentTypes.GenerateAttachmentUploadUrlRequest,
  ambassadorWixContactsV4AttachmentUniversalTypes.GenerateAttachmentUploadUrlResponse,
  ambassadorWixContactsV4AttachmentTypes.GenerateAttachmentUploadUrlResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Attachment.generateAttachmentUploadUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/attachments/{contactId}/upload-url',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAttachments(): __PublicMethodMetaInfo<
  'GET',
  { contactId: string },
  ambassadorWixContactsV4AttachmentUniversalTypes.ListAttachmentsRequest,
  ambassadorWixContactsV4AttachmentTypes.ListAttachmentsRequest,
  ambassadorWixContactsV4AttachmentUniversalTypes.ListAttachmentsResponse,
  ambassadorWixContactsV4AttachmentTypes.ListAttachmentsResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Attachment.listAttachments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/attachments/{contactId}',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAttachment(): __PublicMethodMetaInfo<
  'DELETE',
  { contactId: string; attachmentId: string },
  ambassadorWixContactsV4AttachmentUniversalTypes.DeleteAttachmentRequest,
  ambassadorWixContactsV4AttachmentTypes.DeleteAttachmentRequest,
  ambassadorWixContactsV4AttachmentUniversalTypes.DeleteAttachmentResponse,
  ambassadorWixContactsV4AttachmentTypes.DeleteAttachmentResponse
> {
  const payload = {
    contactId: ':contactId',
    attachmentId: ':attachmentId',
  } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Attachment.deleteAttachment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v4/attachments/{contactId}/{attachmentId}',
    pathParams: { contactId: 'contactId', attachmentId: 'attachmentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAttachment(): __PublicMethodMetaInfo<
  'GET',
  { contactId: string; attachmentId: string },
  ambassadorWixContactsV4AttachmentUniversalTypes.GetAttachmentRequest,
  ambassadorWixContactsV4AttachmentTypes.GetAttachmentRequest,
  ambassadorWixContactsV4AttachmentUniversalTypes.GetAttachmentResponse,
  ambassadorWixContactsV4AttachmentTypes.GetAttachmentResponse
> {
  const payload = {
    contactId: ':contactId',
    attachmentId: ':attachmentId',
  } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Attachment.getAttachment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/attachments/{contactId}/{attachmentId}',
    pathParams: { contactId: 'contactId', attachmentId: 'attachmentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ContactAttachment as ContactAttachmentOriginal,
  ContactAttachmentMediaOneOf as ContactAttachmentMediaOneOfOriginal,
  Image as ImageOriginal,
  Document as DocumentOriginal,
  AttachmentType as AttachmentTypeOriginal,
  AttachmentTypeWithLiterals as AttachmentTypeWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  CrmAttachmentUploadedEvent as CrmAttachmentUploadedEventOriginal,
  CrmAttachment as CrmAttachmentOriginal,
  AttachmentSource as AttachmentSourceOriginal,
  AttachmentMetadata as AttachmentMetadataOriginal,
  AttachmentMedia as AttachmentMediaOriginal,
  AttachmentMediaMediaOneOf as AttachmentMediaMediaOneOfOriginal,
  CommonImage as CommonImageOriginal,
  CommonDocument as CommonDocumentOriginal,
  CrmAttachmentAttachmentType as CrmAttachmentAttachmentTypeOriginal,
  CrmAttachmentAttachmentTypeWithLiterals as CrmAttachmentAttachmentTypeWithLiteralsOriginal,
  CreateDemoAttachmentRequest as CreateDemoAttachmentRequestOriginal,
  DemoContactType as DemoContactTypeOriginal,
  DemoContactTypeWithLiterals as DemoContactTypeWithLiteralsOriginal,
  CreateDemoAttachmentResponse as CreateDemoAttachmentResponseOriginal,
  GenerateAttachmentUploadUrlRequest as GenerateAttachmentUploadUrlRequestOriginal,
  GenerateAttachmentUploadUrlResponse as GenerateAttachmentUploadUrlResponseOriginal,
  ListAttachmentsRequest as ListAttachmentsRequestOriginal,
  Paging as PagingOriginal,
  ListAttachmentsResponse as ListAttachmentsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  DeleteAttachmentRequest as DeleteAttachmentRequestOriginal,
  DeleteAttachmentResponse as DeleteAttachmentResponseOriginal,
  GetAttachmentRequest as GetAttachmentRequestOriginal,
  GetAttachmentResponse as GetAttachmentResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './contacts-v4-attachment-attachments.types.js';
